/**
 * DetailChannelLogo component.
 */
import Screen from '@shared/utils/screen';
import styled from 'styled-components';
import withImage from '@shared/components/utils/hoc/withImage';

/**
 * Styled detail channel logo.
 */
const DetailChannelLogo = styled.img<React.CSSProperties>`
  height: ${80 * Screen.widthRatio}px;
`;

export default withImage(DetailChannelLogo, true);
